import { useUserImageStorageFolder } from '@/hooks/useUserImageStorageFolder'

export function useUserTriviaListImageStorageFolder() {
  return useUserImageStorageFolder({ path: 'trivia_list_images' })
}
